import { useMutation, useQueryClient } from "@tanstack/react-query";

import { ENDPOINTS } from "@/api/application-api";
import { handleResponse } from "@/utils/errorResponseHandlers";
import { jsonAuthHeaders } from "@/utils/headers";
import { displayErrorToast, displayToast } from "@/utils/toast";
import { ToastType } from "@/enums";

interface ClearNotificationsRequest {
  workspaceId: number;
}

interface ClearNotificationsResponse {
  success: boolean;
  message: string;
  dismissed_count: number;
}

export const useClearNotifications = (userToken: string) => {
  const queryClient = useQueryClient();

  return useMutation<ClearNotificationsResponse, string, ClearNotificationsRequest>({
    mutationFn: async ({ workspaceId }: ClearNotificationsRequest) => {
      const response = await fetch(ENDPOINTS.clear_notifications(workspaceId), {
        method: "DELETE",
        headers: jsonAuthHeaders(userToken),
      });

      return handleResponse(response);
    },
    onSuccess: (data, { workspaceId }) => {
      displayToast(data.message || "Notifications cleared", ToastType.success);
      queryClient.invalidateQueries({ queryKey: ["notifications", String(workspaceId)] });
    },
    onError: (error: string) => {
      displayErrorToast(error || "Failed to clear notifications");
    },
  });
};

export default useClearNotifications;
